/*
 * Copyright (c) 2020.
 * Project: Source
 * LastModified: 2/14/20, 3:23 PM
 * Author: diengv < Giáp Văn Điện >
 * Email: diengv@ominext.com
 * File name: index.js
 * File path: D:/Projects/PMS/Source/Client/vuejs/src/helpers/index.js
 */

import * as _ from 'lodash'

const requireModule = require.context('.', true, /\.init.js$/)
requireModule.keys().map(fileName => {
    const module = requireModule(fileName).default
    Object.keys(module).map(name => {
        if (_.has(module[name], 'register')) {
            const mixin = module[name].register(_)
            if (_.isObject(mixin))
                _.mixin(mixin, {'chain': true});
            else
                throw new Error(`Helpers[${name}]: 'register' function must return an object`);
        } else {
            throw new Error(`Helpers[${name}]: Function 'register' not found`);
        }

    })
})


export default _
